module.exports = __webpack_public_path__ + "img/ALPHA PHI ALPHA, JEFFERSON NATIONAL PARK, 1975.8683e3e1.jpg";